<p-toast></p-toast>
<p-dialog height="auto" width="auto" appendTo="body" [(visible)]="displayNewROEDialog" [contentStyle]="{ maxHeight: '90vh', height: 'auto' }"
 (onHide)="this.closeDialogBox();" [style]="{width: '80%', minWidth: '70%', height:'auto', minHeight:'50%','margin':'0px'}"
 [maximizable]="true" minimizeIcon="pi pi-window-minimize" maximizeIcon="pi pi-window-maximize" [resizable]="true"
  closeIcon="pi pi-times" [modal]="false" draggable="true" styleClass="new-roe-dialog" focusOnShow="false">

  <div class="ui-grid-col-12 form-container">
    @if(isLoadingResults){
    <div id="spinnerBox" class="example-loading-shade">
     @if(isLoadingResults){<mat-spinner></mat-spinner>} 
  </div>}

  <div class="col-md-12">
    <div class="col-md-11" style="margin-top: 5px;"><p class="eventTypeText"><b>{{EventType}} Entry</b></p></div>
    <div class="col-md-1" style="margin-top: 5px; position: relative;">
  </div>
  </div>
  <hr/>

  @for (editRow of Editviewcols; track editRow; let i = $index){
    <ng-container>
      @if((editRow.field_Name| lowercase) !== 'firmroeid' && (editRow.field_Name| lowercase) !== 'errorroeid' && (editRow.field_Name| lowercase) !== 'rsmsstatus' && (editRow.field_Name| lowercase) !== 'createdate' && (editRow.field_Name| lowercase) !== 'errorcodelist' &&
      (editRow.field_Name| lowercase) !== 'updatedate' && (editRow.field_Name| lowercase) !== 'lastupdatedby'){
      <span [ngClass]="(editRow.field_Name| lowercase) !== 'buydetails' && (editRow.field_Name| lowercase) !== 'selldetails' && 
    (editRow.field_Name| lowercase) !== 'aggregatedorders'&& editRow.field_Name!=='firmDetails' && editRow.field_Name!=='handlingInstructions' &&
    (editRow.field_Name| lowercase) !== 'clientdetails' && (editRow.field_Name| lowercase) !== 'legdetails'
      && (editRow.field_Name| lowercase) !== 'firmdesignatedid'?'zindex ui-g-12 ui-md-12 ui-lg-4': 'zindex ui-g-12 ui-md-12 ui-lg-12'">
        @if(editRow){
        <span>
          @if((editRow.field_Name| lowercase) !== 'buydetails' && (editRow.field_Name| lowercase) !== 'selldetails' && (editRow.field_Name| lowercase) !== 'aggregatedorders'
             && (editRow.field_Name| lowercase) !== 'clientdetails' && (editRow.field_Name| lowercase) !== 'legdetails' &&  editRow.field_Name!=='firmDetails' && editRow.field_Name !== 'handlingInstructions'&& (editRow.field_Name| lowercase) !== 'firmdesignatedid'){
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div [ngClass]="this.correctCodeLength !== 0 ? 'ui-g-12 ui-md-5 ui-lg-5 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
              <label for="ui_Field_Name">{{editRow.ui_Field_Name}}</label>
              <b>@if(requiredFields.indexOf(editRow.field_Name) >= 0){<sup style="color:red">*</sup>}</b>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg" [ngClass]="{'color-red':nullRequiredFields.indexOf(editRow.field_Name) >= 0}">
              @if((editRow?.datatype | lowercase) == 'choice'){
              <ng-container>
                <p-select [name]="editRow.field_Name +'choice'" [id]="editRow.field_Name+'choice'" [readonly]="editRow?.field_Name =='type'" [options]="editRow.dropdownvalue"
                  [(ngModel)]="editRow.value" appendTo="body"
                  [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                  [placeholder]="editRow.isMultiEdited ? 'Value cleared' : 'Enter Value'" 
                  (ngModelChange)="editRow.isMultiEdited=true"
                  filter="true" required="requiredFields.indexOf(editRow.field_Name) >= 0" [showClear]="true" >
                  <ng-template let-filterCols let-row pTemplate="item">
                    <div class="ui-helper-clearfix" style="text-transform:capitalize">
                      <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                    </div>
                  </ng-template>
                </p-select>
              </ng-container>}
              @else { 
                <ng-container [ngTemplateOutlet]="Int"></ng-container>
              } 
              <ng-template #Int>
                @if((editRow?.datatype | lowercase) =='int' || (editRow?.datatype | lowercase)=='float' || 
              (editRow?.datatype | lowercase) =='number' || (editRow?.datatype | lowercase)=='bigdecimal'){
                <ng-container>
                <input type="number" ng-pattern="/^[0-9]$/" [name]="editRow.field_Name +'int'" [id]="editRow.field_Name+'int'" 
                maxlength="10" required="requiredFields.indexOf(editRow.field_Name) >= 0" pInputText [(ngModel)]="editRow.value"
                [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                (ngModelChange)="editRow.isMultiEdited=true" 
                [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" />
              </ng-container>}
              @else { 
                <ng-container [ngTemplateOutlet]="Boolean"></ng-container>
              } 
              </ng-template>
              <ng-template #Boolean>
                @if((editRow?.datatype | lowercase)=='boolean'){
                <ng-container>
                  <p-select [name]="editRow.field_Name +'boolean'" [id]="editRow.field_Name+'boolean'" [options]="BooleanDropDown" [(ngModel)]="editRow.value" appendTo="body"
                  [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                  [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                  (ngModelChange)="editRow.isMultiEdited=true" filter="true"
                    required="requiredFields.indexOf(editRow.field_Name) >= 0" >
                    <ng-template let-filterCols let-row pTemplate="item">
                      <div class="ui-helper-clearfix" style="text-transform:capitalize">
                        <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                      </div>
                    </ng-template>
                  </p-select>
                </ng-container>}
                @else { 
                  <ng-container [ngTemplateOutlet]="String"></ng-container>
                } 
              </ng-template>
              <ng-template #String>
                @if((editRow?.datatype | lowercase)=='string' || (editRow?.datatype | lowercase)=='char'){
                <ng-container>
                  @if(editRow.field !='symbol' && editRow.field !='type'){
                  <input [name]="editRow.field_Name +'string'" [id]="editRow.field_Name+'string'" [disabled]="editRow.isDisable"
                    required="requiredFields.indexOf(editRow.field_Name) >= 0" type="text" [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                    (ngModelChange)="editRow.isMultiEdited=true" 
                    [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText
                    [(ngModel)]="editRow.value" />}
                    @if(editRow.field =='symbol' || editRow.field =='type'){
                  <input [name]="editRow.field_Name +'string'" [id]="editRow.field_Name+'string'" 
                  [disabled]="editRow.isDisable"
                  (ngModelChange)="editRow.isMultiEdited=true" 
                  [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" 
                  pInputText [id]="editRow.header" [(ngModel)]="editRow.value" />}
                </ng-container>}
                @else { 
                  <ng-container [ngTemplateOutlet]="Date"></ng-container>
                } 
              </ng-template>
              <ng-template #Date>
                @if((editRow?.datatype | lowercase)=='date'){
                <ng-container>
                  <p-datepicker appendTo="body" [touchUI]="true" [id]="editRow.field_Name+'date'"
                  [name]="editRow.field_Name +'date'"
                  [(ngModel)]="editRow.value" placeholder="Enter Value"
                  [iconDisplay]="'input'" 
                  required="requiredFields.indexOf(editRow.field_Name) >= 0"
                  [showIcon]="true" selectionMode="range"
                  [style]="{'width':'85% !important','height':'25px !important','padding':'3px !important'}"
                  inputId="icondisplay" [motionOptions]="{ duration: 0 }"/>
                </ng-container>}
                @else { 
                  <ng-container [ngTemplateOutlet]="DateTime"></ng-container>
                } 
              </ng-template>
              <ng-template #DateTime>
                @if((editRow?.datatype | lowercase)=='datetime'){
                <ng-container>
                  <div class="ui-g-12 nopadding ">
                    <input [name]="editRow.field_Name +'datetime'" [id]="editRow.field_Name+'datetime'" type="text" [placeholder]="editRow.isMultiEdited ?'Value cleared' : ((editRow.field_Name| lowercase).indexOf('keydate') > 0 ? 'yyyyMMddT000000':'yyyyMMddTHHmmss000000')" 
                    (ngModelChange)="editRow.isMultiEdited=true" 
                    [ngClass]="{'input-color-edit':editRow.isMultiEdited,'inp-color-white':!editRow.isMultiEdited}" pInputText
                      [(ngModel)]="editRow.value" (focusout)="checkDateFormat(editRow)"/>                     
                  </div>
                </ng-container>}
                @else { 
                  <ng-container [ngTemplateOutlet]="Timestamp"></ng-container>
                } 
              </ng-template>
              <ng-template #Timestamp>
                @if((editRow?.datatype | lowercase)=='timestamp'){
                <ng-container>
                  <div class="ui-g-12 nopadding ">
                    <input [name]="editRow.field_Name +'datetime'" [id]="editRow.field_Name+'datetime'" type="text"
                    [placeholder]="this.userService.getDateTimeTFormatePattern(editRow.field_Name)" 
                    [matTooltip]="this.userService.getDateTimeTFormatePattern(editRow.field_Name)"
                    (change)="getDateTimeTFormate(editRow.field_Name,editRow.value,i)"
                    [ngClass]="this.userService.timeStampErrorField == editRow.field_Name ?'error_timeStamp' :editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText
                    [(ngModel)]="editRow.value"
                    (ngModelChange)="editRow.isMultiEdited=true"
                     />
                  </div>  
                </ng-container>
              }
              @else { 
                <ng-container [ngTemplateOutlet]="ChoiceValues"></ng-container>
              } 
              </ng-template>
              <ng-template #ChoiceValues>
                @if((editRow?.datatype | lowercase)=='choicevalues'){
                <ng-container>
                  @if(editRow.ui_Field_Name !== 'handlingInstructions'){
                  <div class="ui-g-12 ui-md-6 ui-lg-4 quick-view-grid-row-hg"
                    [ngClass]="{'color-red':nullRequiredFields.indexOf(editRow.field_Name) >= 0}">
                    <p-select [name]="editRow.field_Name +'choicevaluesDropdown'" [id]="editRow.field_Name+'choicevaluesDropdown'" [readonly]="editRow?.field_Name =='type'" [options]="editRow.dropdownvalue"
                      [(ngModel)]="newLabel" appendTo="body" (onChange)="setEditRowValue(i,newLabel)"
                      [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                      [placeholder]="editRow.isMultiEdited ?'Value cleared' : newLabel" 
                      (ngModelChange)="editRow.isMultiEdited=true" filter="true" required="true" >
                      <ng-template let-filterCols let-row let-rowIndex pTemplate="item">
                        <div class="ui-helper-clearfix" style="text-transform:capitalize">
                          <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}
                          </div>
                        </div>
                      </ng-template>
                    </p-select>
                  </div>}
                  @if(editRow.ui_Field_Name !== 'handlingInstructions'){
                  <div class="ui-g-12 ui-md-6 ui-lg-8 quick-view-grid-row-hg">
                    <input [name]="editRow.field_Name +'choicevalues'" [id]="editRow.field_Name+'choicevalues'" required="requiredFields.indexOf(editRow.field_Name) >= 0" type="text" placeholder="Enter Value" style="width:100%" pInputText
                      [(ngModel)]="timeInForceValue" />
                  </div>}
                  @if(editRow.ui_Field_Name === 'handlingInstructions'){
                  <div>
                    <input [name]="editRow.field_Name +'choicevalues'" [id]="editRow.field_Name+'choicevalues'" required="requiredFields.indexOf(editRow.field_Name) >= 0" type="text" placeholder="Enter Value" style="width:100%" pInputText
                      [(ngModel)]="editRow.value" />
                  </div>}
                </ng-container>}
              </ng-template>
            </div>
            @if(this.correctCodeLength !== 0 && editRow.isDisable){
            <div class="ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg">
              <i pTooltip="Clear Value" (click)="clearValue(editRow)" tooltipPosition="right"
                class="fa fa-times cursor-pointer clear-all-icon" aria-hidden="true"></i>
            </div>}
          </div>}
          <!-- Nested Json Details -->
           @if((editRow.field_Name| lowercase) === 'aggregatedorders'){
          <div class="ui-grid-col-12 horizontal-scroll">
            <mat-divider></mat-divider>
            <span class="singleEditTitles"><b>Aggregated Order Details</b></span>
            <p-table [columns]="aggoOrdersCols" [value]="editRow.value" #dt1>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th id="header"></th>
                  @for (col of columns; track col;){
                  <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    {{col.header}}
                  </th>}
                </tr>
              </ng-template>           
              <ng-template pTemplate="body" let-aggoOrdersRowData let-ri="rowIndex" let-columns="columns">
                <tr [pSelectableRow]="aggoOrdersRowData">
                  <!-- Logic of Aggo Details Add/Delete Row -->
                    @if((editRow.field_Name | lowercase)==='aggregatedorders' && (editRow.value.length === (ri+1))){
                      <td class="text-center">
                        @if(editRow.value.length > 1) {
                          <a (click)="dataService.removeJsonFieldDetails(editRow.value, ri);"><em class="pi pi-minus"></em></a>&nbsp;
                        }
                        <a (click)="dataService.addJsonFieldDetails(editRow.value, 'aggregatedOrders');"><em class="pi pi-plus"></em></a>
                      </td>
                    }
                    @if((editRow.field_Name | lowercase)==='aggregatedorders' && (editRow.value.length !== (ri+1))){
                      <td class="text-center"><a (click)="dataService.removeJsonFieldDetails(editRow.value, ri);"><em class="pi pi-minus"></em></a></td>
                    }
                  <!-- End Logic of Aggo Details Add/Delete Row -->
                  @for (col of columns; track col;){
                  <td [style]="editRow.field_Name==='side' ? 'min-width: 160px !important' : 'min-width: 30px  !important'" pEditableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                        <input [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'" [(ngModel)]="aggoOrdersRowData[col.field]">}
                        <!-- set int  -->
                         @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                        <input [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'"
                        [(ngModel)]="aggoOrdersRowData[col.field]">}
                      </ng-template>
                      <ng-template pTemplate="output">
                        @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                        <span>
                          {{aggoOrdersRowData[col.field]}}
                        </span>}
                        <!-- set int  -->
                         @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                        <span>
                          {{aggoOrdersRowData[col.field]}}
                        </span>}
                      </ng-template>
                  </p-cellEditor>
                    <!-- set String -->                  
                  </td>}
                </tr>
              </ng-template>
            </p-table>
          </div>}
          @if(editRow.field_Name=='handlingInstructions'){
          <div class="ui-grid-col-8 container nopadding">
            <mat-divider></mat-divider>
            <p-table [columns]="handlingInstructionCols" [value]="handlingInstructionData" #dt2 id="handlingInstructionTable" 
              class = "cell-editor-table">
              <ng-template pTemplate="caption">
                <div class="row">
                    <div class="col-md-4" style="text-align:left">
                        <span class="singleEditTitles"><b>Handling Instructions</b></span>
                      </div>
                      <div class="col-md-4" style="text-align:left">
                        <p-multiSelect [name]="editRow.field_Name +'multiselect'" [id]="editRow.field_Name+'multiselect'" appendTo="body" [options]="this.userService.handlingInstructions" [(ngModel)]="handlingInstructionCols" optionLabel="header"
                         selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}"  placeholder="Choose Columns" class="new-roe-dropdown"></p-multiSelect>
                    </div>
                </div>     
            </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for (col of columns; track col;){
                  <th id="colHeader">
                    {{col.header}}
                  </th>}
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-handlingInstructionData let-columns="columns">
                <tr >
                  @for (col of columns; track col;){
                  <td style="width:10px" pEditableColumn>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input [name]="editRow.field_Name + col.field" [id]="editRow.field_Name+'1'"  [(ngModel)]="handlingInstructionData[col.field]" >
                      </ng-template>
                      <ng-template pTemplate="output">
                        <span >
                          {{handlingInstructionData[col.field]}}
                        </span>
                      </ng-template>
                  </p-cellEditor>
                  
                  </td>}
                </tr>
              </ng-template>
            </p-table>
          </div>}
          @if(editRow.field_Name=='firmDesignatedID'){
          <div class="nopadding">
            <div class="col-md-5 nopadding ">
               <div class="row ">
                 <div class="col-md-3"  style="margin-top: -7px !important;"><label for="GivenName"><span class="singleEditTitles">GivenName</span></label></div>
                   <div class="col-md-2"><p-toggleswitch [(ngModel)]="checked" name="checked" styleClass="inputSwitch"></p-toggleswitch></div>
                   <div class="col-md-7"><span class="singleEditTitles"><input [disabled]="!checked" placeholder="Enter givenName" [(ngModel)]="givenNameForFDID" [name]="givenNameForFDID"></span>
                     <p-button type="button" icon="fa fa-check" [disabled]="!checked" (click)="getFDID(i)"></p-button></div>
                </div> 
            </div>
            <div class="col-md-7 nopadding">
              <div class="row">
                 <div class="col-md-3"><span class="singleEditTitles"> Firm Designated ID</span></div>
                 <div class="col-md-1"><p-toggleswitch (click)="editRow.value = dataService.trimValue(editRow.value)" [(ngModel)]="fdidChecked" name="fdidChecked" styleClass="inputSwitch"></p-toggleswitch></div>
                 <div class="col-md-8"><span class="singleEditTitles"> <input [disabled]="!fdidChecked" placeholder="Enter Firm Designated ID" (change)="editRow.value = dataService.trimValue(editRow.value)" [(ngModel)]="editRow.value" [name]="editRow.value" style="width: 100%"></span></div>
              </div> 
            </div>
           </div>}
          @if(editRow.field_Name=='buyDetails' || editRow.field_Name=='sellDetails' || editRow.field_Name=='clientDetails' || editRow.field_Name=='firmDetails' || editRow.field_Name=='legDetails'){
           <div class="ui-grid-col-12 horizontal-scroll">
            <mat-divider></mat-divider>
            <span class="singleEditTitles"><b>{{editRow.field_Name === 'buyDetails' ? 'Buy Details': editRow.field_Name === 'sellDetails' ? 'Sell Details' : editRow.field_Name=='clientDetails' ? 'Client Details': editRow.field_Name=='firmDetails' ? 'Firm Details':editRow.field_Name=='legDetails' ? 'Leg Details': ''}}</b></span>
            <p-table [columns]="getChildColumns(editRow.field_Name)" [value]="editRow.value" #dt2>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @if((editRow.field_Name | lowercase)==='legdetails') {
                    <th id="tableHeader"></th>
                  }
                  @for (col of columns; track col;){
                  <th id="columns" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    {{col.header}}
                  </th>}
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-tradeSideRowData let-rowIndex="rowIndex" let-columns="columns">
                <tr [pSelectableRow]="tradeSideRowData">
                  <!-- Logic of Leg Details Add/Delete Row Buttons -->
                    @if((editRow.field_Name | lowercase)==='legdetails' && (editRow.value.length === (rowIndex+1))){
                      <td class="text-center">
                        @if(editRow.value.length > 1) {
                          <a (click)="dataService.removeJsonFieldDetails(editRow.value, rowIndex)"><em class="pi pi-minus"></em></a>&nbsp;
                        }
                        <a (click)="dataService.addJsonFieldDetails(editRow.value, 'legDetails');"><em class="pi pi-plus"></em></a>
                      </td>
                    }
                    @if((editRow.field_Name | lowercase)==='legdetails' && (editRow.value.length !== (rowIndex+1))){
                      <td class="text-center"><a (click)="dataService.removeJsonFieldDetails(editRow.value, rowIndex)"><em class="pi pi-minus"></em></a></td>
                    }
                  <!-- End Logic of Leg Details Add/Delete Row Buttons -->
                  @for (col of columns; track col;){
                  <td [style]="editRow.field_Name==='side' ? 'min-width: 160px !important' : 'min-width: 30px  !important'" pEditableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <!-- set string -->
                        @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float' && (col?.dropdown | lowercase) === 'no'){
                          <input [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'" [(ngModel)]="tradeSideRowData[col.field]">
                        }
                        <!-- set int  -->
                        @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                          <input [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'"
                            [(ngModel)]="tradeSideRowData[col.field]">
                        }
                        <!-- set dropdown -->
                        @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                          <p-select styleClass="tbl-form-dropdown" appendTo="body" [name]="tradeSideRowData[col.field]+'singleselect'" [id]="tradeSideRowData[col.field]+'singleselect'" 
                            [options]="getROEDetailsFieldDropdownValues(editRow, col, tradeSideRowData)" [(ngModel)]="tradeSideRowData[col.field]" [disabled]="col.disabled" [showClear]="true" 
                            [placeholder]="'Enter Value'">
                          </p-select>
                        }
                      </ng-template>
                      <ng-template pTemplate="output">
                        @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                        <span>
                          {{tradeSideRowData[col.field]}}
                        </span>}
                        <!-- set int  -->
                         @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                        <span>
                          {{tradeSideRowData[col.field]}}
                        </span>}
                      </ng-template>
                  </p-cellEditor>
                    <!-- set String -->
                  </td>}
                </tr>
              </ng-template>
            </p-table>
          </div>}
        </span>}
      </span>}
    </ng-container>}
  </div>
  <!-- <p-footer> -->
    <div class="ui-dialog-buttonpane ui-helper-clearfix btn-position">
      <p-button type="button" id="catExceptionClear" icon="fa fa-close" class="userActionBtn new-roe-footer-button" (click)="Edit=false;this.closeDialog.emit(false); isClickedOnce = false;clearData();" label="Clear"></p-button>
      <p-button type="button" icon="fa fa-close" id="newROEEntryCloseBtn" class="userActionBtn new-roe-footer-button cat-close-footer-button" (click)="this.closeDialogBox();" label="Close"></p-button>
      <p-button type="submit" (click)="save()" [disabled]="this.screenType === 'finraException'" icon="fa fa-check" id="catExceptionSave" class="userActionBtn new-roe-footer-button" label="Save"></p-button>
    </div>
</p-dialog>